import IndexDefault from '../pages/index';
import { Index } from '../pages/index';
import CodeAccessApplication from '../pages/codeAccessApplication/codeAccessApplication';
import { WizardProvider } from "../LoanApplicationContext";
import { routeCreator } from '../../../helpers/routeCreator';

const WrappedCodeAccessIndex = () => (
    <WizardProvider>
      <IndexDefault />
    </WizardProvider>
  );

export const ROUTE_LOAN_APPLICATION = routeCreator(
  WrappedCodeAccessIndex,
  '/loans/application/:id',
  'Loan Application',
  'page.loan.application',
  { exact: true }
);


const WrappedFastLoanApplication = () => (
  <WizardProvider>
    <Index />
  </WizardProvider>
);

// Same path as ROUTE_LOAN_APPLICATION but without the permission HOC,
// used for fast-login (unauthenticated) users
export const ROUTE_LOAN_APPLICATION_FAST = routeCreator(
  WrappedFastLoanApplication,
  '/loans/application/:id',
  'Fast Loan Application',
  'page.loan.application.fast',
  { exact: true }
);

const WrappedCodeAccess = () => (
  <WizardProvider>
    <CodeAccessApplication />
  </WizardProvider>
);

export const ROUTE_LOAN_APPLICATION_CODE_ACCESS = routeCreator(
  WrappedCodeAccess,
  '/loans/access-application',
  'Code Access Loan Application',
  'page.loan.code.access',
  { exact: true }
);


const router = {
  ROUTE_LOAN_APPLICATION,
  ROUTE_LOAN_APPLICATION_CODE_ACCESS,
};

export default router;
